import { Layers, Award, Lightbulb, Star, Users, Wrench } from "lucide-react";
import Autoplay from "embla-carousel-autoplay";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

const benefits = [
  {
    icon: Layers,
    title: "One Company, Complete Delivery",
    copy: "From creative ideas to technical installation and ongoing support, Robust Entertainment can manage the complete entertainment solution under one roof.",
  },
  {
    icon: Award,
    title: "20-Year Track Record",
    copy: "A long-standing reputation built through consistent delivery for leading UK holiday centres, including 20 years as exclusive supplier to Park Holidays UK.",
  },
  {
    icon: Lightbulb,
    title: "Creative & Commercial Understanding",
    copy: "We understand what makes entertainment work for real venues, real teams and real audiences, not just creatively, but operationally.",
  },
  {
    icon: Star,
    title: "Production Quality That Elevates Your Brand",
    copy: "From main stage shows to branded characters and visual content, everything is designed to feel professional, memorable and aligned with your venue.",
  },
  {
    icon: Users,
    title: "Training That Improves Guest Experience",
    copy: "We help entertainment teams build confidence, professionalism and performance skills across daytime activities, character experiences and main stage productions.",
  },
  {
    icon: Wrench,
    title: "Technical Confidence & Ongoing Backup",
    copy: "Sound, lighting, LED screens and technical installations are delivered by an efficient team, with quality equipment and dependable support moving forward.",
  },
];

export const Benefits = () => {
  return (
    <section id="benefits" className="relative py-14 lg:py-20 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-[#FF2A2A]/5 blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-sm sm:text-base font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-4 text-center">Why Us</p>
        <h2 className="font-heading heading-fluid font-medium tracking-normal text-metal max-w-3xl mx-auto mb-10 text-center">
          One company. Complete entertainment delivery. Proven for 20 years.
        </h2>
        <div className="rounded-3xl p-[2px] bg-gradient-to-br from-[#F3E5AB] via-[#D4AF37] to-[#8a6a10]" data-testid="benefits-carousel">
          <div className="rounded-3xl bg-[#0A0A0A] px-12 py-8">
            <Carousel opts={{ align: "start", loop: true }} plugins={[Autoplay({ delay: 3500, stopOnInteraction: false, stopOnMouseEnter: true })]}>
            <CarouselContent>
              {benefits.map((b) => (
                <CarouselItem key={b.title} className="md:basis-1/2 lg:basis-1/3">
                  <div className="h-full group bg-[#121212] border border-white/10 rounded-2xl p-8 hover:border-[#D4AF37]/50 transition-colors duration-300 text-center flex flex-col items-center">
                    <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FF2A2A]/10 border border-[#FF2A2A]/30 mb-6 group-hover:shadow-[0_0_20px_rgba(255,42,42,0.3)] transition-shadow duration-300">
                      <b.icon size={22} className="text-[#FF4D4D]" />
                    </span>
                    <h3 className="font-heading text-xl font-medium text-white mb-3">{b.title}</h3>
                    <p className="text-base text-zinc-300 leading-relaxed">{b.copy}</p>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious data-testid="benefits-carousel-prev" className="border-white/20 bg-black/50 text-white hover:bg-[#FF2A2A] hover:text-white" />
            <CarouselNext data-testid="benefits-carousel-next" className="border-white/20 bg-black/50 text-white hover:bg-[#FF2A2A] hover:text-white" />
          </Carousel>
          </div>
        </div>
        <div className="divider-gold mt-14" />
      </div>
    </section>
  );
};

export default Benefits;
